import { Bot, GitBranch, Database, Wifi, Info, Settings, Rocket, Palette, Globe, CreditCard, HardDrive } from 'lucide-react';

export interface SettingsItem {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  href: string;
  category: 'general' | 'integrations' | 'advanced';
}

/**
 * Get the list of settings items with plain text
 * @returns Array of settings items
 */
export const getSettingsItems = (): SettingsItem[] => [
  // General settings
  {
    id: 'appearance',
    title: 'Appearance',
    description: 'Customize the look and feel of your workspace',
    icon: Palette,
    href: '/settings/appearance',
    category: 'general',
  },
  {
    id: 'preferences',
    title: 'Preferences',
    description: 'Manage your general application preferences',
    icon: Globe,
    href: '/settings/preferences',
    category: 'general',
  },
  // Integrations
  {
    id: 'ai',
    title: 'AI Settings',
    description: 'Configure AI providers and API keys',
    icon: Bot,
    href: '/settings/ai',
    category: 'integrations',
  },
  {
    id: 'nostr',
    title: 'Nostr Settings',
    description: 'Configure relay connections and Nostr preferences',
    icon: Wifi,
    href: '/settings/nostr',
    category: 'integrations',
  },
  {
    id: 'git',
    title: 'Git Settings',
    description: 'Configure Git credentials for HTTP authentication',
    icon: GitBranch,
    href: '/settings/git',
    category: 'integrations',
  },
  {
    id: 'deploy',
    title: 'Deployment',
    description: 'Configure deployment providers',
    icon: Rocket,
    href: '/settings/deploy',
    category: 'integrations',
  },
  {
    id: 'database',
    title: 'Database',
    description: 'Connect database providers like Supabase',
    icon: Database,
    href: '/settings/database',
    category: 'integrations',
  },
  {
    id: 'integrations',
    title: 'Payments',
    description: 'Connect payment providers like Stripe',
    icon: CreditCard,
    href: '/settings/integrations',
    category: 'integrations',
  },
  // Advanced
  {
    id: 'storage',
    title: 'Storage',
    description: 'Export files and manage local data',
    icon: HardDrive,
    href: '/settings/storage',
    category: 'advanced',
  },
  {
    id: 'system',
    title: 'System Settings',
    description: 'Configure system-level settings and advanced options',
    icon: Settings,
    href: '/settings/system',
    category: 'advanced',
  },
  {
    id: 'about',
    title: 'About',
    description: 'Information about AfterHours',
    icon: Info,
    href: '/settings/about',
    category: 'advanced',
  },
];

export const getSettingsCategories = () => ({
  general: 'General',
  integrations: 'Integrations',
  advanced: 'Advanced',
});
